<h4 class="mb-3">
	<span *ngIf="affidavit.id">Edit</span
	><span *ngIf="!affidavit.id">Add a new</span> statement
</h4>
<p>
	Please fill in the details below to <span *ngIf="affidavit.id">edit the</span
	><span *ngIf="!affidavit.id">add a new</span> statement
</p>
<hr class="my-5" />
<app-container type="dark">
	<app-input
		class="mb-5"
		label="Name of debtor"
		name="debtor"
		type="text"
		[(ngModel)]="affidavit.debtor"
		(ngModelChange)="changed()"
		[testHook]="testHooks.NameOfDebtor"
	></app-input>
	<app-input
		class="mb-5"
		label="Name of plaintiff"
		name="plaintiff"
		type="text"
		[(ngModel)]="affidavit.plaintiff"
		(ngModelChange)="changed()"
		[testHook]="testHooks.NameOfPlaintiff"
	></app-input>
	<app-input
		class="mb-5"
		label="Amount of the judgement"
		name="amount"
		type="cents"
		[(ngModel)]="affidavit.amount"
		(ngModelChange)="changed()"
		[startIcon]="ICON.DOLLAR"
		[testHook]="testHooks.AmountOfTheJudgement"
	></app-input>
	<app-input
		class="mb-5"
		label="Amount of costs"
		name="costs"
		type="cents"
		[(ngModel)]="affidavit.costs"
		(ngModelChange)="changed()"
		[startIcon]="ICON.DOLLAR"
		[testHook]="testHooks.AmountOfCosts"
	></app-input>
	<app-input
		label="Writ execution number"
		name="executionNumber"
		type="text"
		[(ngModel)]="affidavit.executionNumber"
		(ngModelChange)="changed()"
		[testHook]="testHooks.WritExecutionNumber"
	></app-input>
</app-container>
<div class="flex justify-between items-center mt-10">
	<app-button
		btn="tertiary"
		(click)="cancel()"
		size="small"
		[testHook]="testHooks.CancelButton"
		>Cancel</app-button
	>
	<app-button
		(click)="save()"
		size="small"
		[loading]="busy"
		[disabled]="busy"
		[testHook]="testHooks.SaveButton"
		>Save</app-button
	>
</div>
